import { render, staticRenderFns } from "./cuTitle3.vue?vue&type=template&id=85bf56de&scoped=true&"
import script from "./cuTitle3.vue?vue&type=script&lang=js&"
export * from "./cuTitle3.vue?vue&type=script&lang=js&"
import style0 from "./cuTitle3.vue?vue&type=style&index=0&id=85bf56de&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bf56de",
  null
  
)

export default component.exports